<template>
  <div class="other">
    <Form ref="formInline" :label-width="80" inline>
      <FormItem label="退款原因">
        <Select
          v-model="reason"
          placeholder="请选择退款原因"
          style="width: 350px"
        >
          <Option v-for="item in reasonList" :key="item" :value="item">{{
            item
          }}</Option>
        </Select>
      </FormItem>
      <FormItem v-if="reason==='其他原因'" label="退款备注">
        <Input
          v-model="remark"
          type="text"
          placeholder="请输入退款备注"
          style="width: 350px"
        >
        </Input>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { refundReason } from '../assets/BatchRefundIndex';
import orderCenter from '@/request/orderCenter/index.js';
export default {
  props: {
    searchData: {
      type: Object,
      default: () => {}
    },
    selectDetailIdList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      remark: '',
      reason: '',
      reasonList: refundReason
    };
  }
};
</script>

<style lang="scss" scoped>
.row {
  font-size: 14px;
  margin-bottom: 16px;
}
</style>
